// extracted by mini-css-extract-plugin
export default {"avatar":"PrincipalEditorControl_avatar__gRFFo","name":"PrincipalEditorControl_name__OJeV7"};